import type { RefCallback } from 'react'
import { useInView } from 'react-intersection-observer'

import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'

type StructuredFacilitiesOffer = App.HotelOffer | App.Offer

function getStructuredFacilities(offerDetails: StructuredFacilitiesOffer): Array<App.StructuredFacilityGroup> | undefined {
  return 'structuredFacilities' in offerDetails ? offerDetails.structuredFacilities : undefined
}

interface StructuredFacilitiesReworkState {
  structuredFacilitiesReworkActivationRef: RefCallback<HTMLDivElement>
  structuredFacilitiesRework?: Array<App.StructuredFacilityGroup>
}

function useStructuredFacilitiesReworkForFacilities(
  structuredFacilities: Array<App.StructuredFacilityGroup> | undefined,
): StructuredFacilitiesReworkState {
  const hasStructuredFacilities = !!structuredFacilities?.length
  const [structuredFacilitiesReworkActivationRef, structuredFacilitiesReworkInView] = useInView({
    triggerOnce: true,
    threshold: 0.25,
  })
  const { isAnyVariant } = useExperiment(Experiments.croFacilitiesRework, {
    canActivate: structuredFacilitiesReworkInView && hasStructuredFacilities,
  })

  return {
    structuredFacilitiesReworkActivationRef,
    structuredFacilitiesRework: isAnyVariant && hasStructuredFacilities ? structuredFacilities : undefined,
  }
}

export function usePropertyStructuredFacilitiesRework(
  property: App.Property.Property,
): StructuredFacilitiesReworkState {
  return useStructuredFacilitiesReworkForFacilities(property.structuredFacilities)
}

function useStructuredFacilitiesRework(offerDetails: StructuredFacilitiesOffer): StructuredFacilitiesReworkState {
  return useStructuredFacilitiesReworkForFacilities(getStructuredFacilities(offerDetails))
}

export default useStructuredFacilitiesRework
